export const identity = {
  identityFormTitle: "Voltooi jou besonderhede",
  identityFormDescription: "Voer jou ID-dokument in om voort te gaan.",
  identityFormSubmit: "Gaan voort",
  identityFormSave: "Stoor en gaan voort",
  identityFormVerifying: "Kontroleer...",
  identityFormSaving: "Stoor...",
  identityFormErrorTitle: "Kon nie voltooi nie",
  identityCedulaLabel: "ID-tipe en nommer",
  identityIdTypeLabel: "ID-tipe",
  identityCedulaRequired: "Voer jou dokumentnommer in",
  identityCedulaLength: "Moet tussen 6 en 10 syfers bevat",
  identityRutPlaceholder: "12345678-9",
  identityRutRequired: "Voer jou Chileense RUT in",
  identityRutInvalid: "Voer 'n geldige Chileense RUT in (formaat: 12345678-9)",
  identityFirstNameLabel: "Voornaam",
  identityFirstNamePlaceholder: "Jou voornaam",
  identityFirstNameRequired: "Voer jou voornaam in",
  identityLastNameLabel: "Van",
  identityLastNamePlaceholder: "Jou van",
  identityLastNameRequired: "Voer jou van in",
  identityBirthdateLabel: "Geboortedatum",
  identityBirthdatePlaceholder: "Kies jou geboortedatum",
  identityBirthdateRequired: "Voer jou geboortedatum in",
  identityManualFallbackHint:
    "Ons kon nie jou ID outomaties verifieer nie. Voltooi asseblief jou besonderhede handmatig om voort te gaan.",
  identityChangeCedula: "Verander ID",
  identityVerifiedLabel: "ID geverifieer",

  identityError_generic: "Ons kon nie jou registrasie voltooi nie. Probeer asseblief weer.",
  identityError_invalid_document: "Die dokumentformaat is nie geldig nie.",
  identityError_underage: "Jy moet ten minste 18 jaar oud wees om te registreer.",
  identityError_document_not_found: "Ons kon nie jou ID in die burgerlike register vind nie.",
  identityError_document_already_registered: "Hierdie ID is reeds geregistreer. Teken in met jou bestaande rekening.",
  identityError_verification_expired: "Verifikasie het verval. Voer asseblief jou ID weer in.",
  identityError_verification_invalid: "Verifikasie is nie geldig nie. Voer asseblief jou ID weer in.",
  identityError_verification_required: "Jy moet jou ID verifieer voordat jy met Google voortgaan.",
  identityError_kyc_unavailable: "Die verifikasiediens is nie beskikbaar nie. Probeer later weer.",
  identityError_rate_limit_exceeded: "Te veel pogings. Wag 'n paar minute en probeer weer.",

  onboardingModalTitle: "Voltooi jou profiel",
  onboardingContinue: "Gaan voort",
  onboardingBack: "Terug",
  onboardingLater: "Ek sal dit later doen",
  onboardingConfirm: "Bevestig en stoor",
  onboardingPagoMovilTitle: "Pago Móvil",
  onboardingPagoMovilDescription: "Voeg jou bank en foon by vir bolívar-deposito's en -onttrekkings.",
  onboardingPhoneDigits: "Voer die oorblywende 7 foonsyfers in",
  onboardingSuccessTitle: "Profiel voltooi",
  onboardingSuccessMessage: "Jou identiteit en Pago Móvil-rekening is opgestel.",
  onboardingSuccessProfileOnly: "Jou besonderhede is suksesvol gestoor.",
  onboardingErrorTitle: "Kon nie registrasie voltooi nie",
  onboardingErrorMessage: "Kontroleer jou besonderhede en probeer weer.",
  onboardingReferralWarningTitle: "Verwysingskode nie toegepas nie",
};
